import comp from "./RubricTableWithReorderingWrapper";
export default comp;
